module.exports = __webpack_public_path__ + "img/bg-client-circle-long.f335b245.svg";